import { useCallback, useEffect, useState } from "react";

import { LinkIcon } from "@lucide/icons";

import type { OpenAPI } from "simplydo/interfaces";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import { useAppSelector } from "store";

import RowComponent from "components/lib/RowComponent";

const HomePages = () => {
  const [pinnedPages, setPinnedPages] = useState<
    OpenAPI.Schemas["CustomPage"][]
  >([]);
  const user = useAppSelector((state) => state.user);
  const orgId = user?.organisation;

  const getPinnedPages = useCallback(() => {
    if (!orgId) return;

    api.pages.getPinned(
      "organisation",
      orgId,
      ({ pages: newPages }) => {
        setPinnedPages(newPages);
      },
      () => {},
    );
  }, [orgId]);

  useEffect(() => {
    getPinnedPages();
  }, [getPinnedPages]);

  if (!pinnedPages.length) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title>Pages</RowComponent.Title>
      </RowComponent.Fill>
      {pinnedPages.map((page) => (
        <RowComponent.Cell key={page._id} asChild>
          <a target="_blank" rel="noreferrer" href={page.link}>
            <Icon icon={LinkIcon} size="large" />
            <RowComponent.Title>{page.title}</RowComponent.Title>
          </a>
        </RowComponent.Cell>
      ))}
    </RowComponent>
  );
};

export default HomePages;
